import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import { Control, UseFormSetValue } from 'react-hook-form'
import DateTimePicker from '@/components/Form/DateTimePicker'
import { AssetFormData } from '..'

interface EffectiveDatesSectionProps {
    control: Control<any>
    setValue: UseFormSetValue<any>
    formData: AssetFormData
}

const EffectiveDatesSection: React.FC<EffectiveDatesSectionProps> = ({
    control,
    setValue,
    formData,
}) => {
    const { t } = useTranslation('asset')
    const [isEndDateEnabled, setIsEndDateEnabled] = useState(!!formData.endDate)

    // Sync isEndDateEnabled with formData.endDate if it becomes empty/non-empty from outside (hydration)
    useEffect(() => {
        if (formData.endDate && !isEndDateEnabled) {
            setIsEndDateEnabled(true)
        }
    }, [formData.endDate])

    const handleCheckboxChange = (checked: boolean) => {
        setIsEndDateEnabled(checked)
        if (!checked) {
            setValue('endDate', null)
        }
    }

    return (
        <div className="rounded-lg border border-gray-100 p-4 space-y-4">
            <h4 className="text-sm font-medium text-gray-800">
                {t('form.effectivePeriod', 'Thời hạn hiệu lực')}
            </h4>
            <div className="space-y-4">
                <DateTimePicker
                    control={control}
                    name="startDate"
                    label={t('labels.startDate', 'Ngày bắt đầu')}
                    required
                    size="medium"
                    includeTime={false}
                    placeholder={t('labels.selectDate', 'Chọn ngày')}
                />
                <div className="flex items-center space-x-2">
                    <Checkbox
                        id="enableEndDate"
                        checked={isEndDateEnabled}
                        onCheckedChange={handleCheckboxChange}
                    />
                    <Label
                        htmlFor="enableEndDate"
                        className="text-sm font-normal text-gray-700 leading-none cursor-pointer"
                    >
                        {t('labels.specifyEndDate', 'Xác định ngày kết thúc')}
                    </Label>
                </div>
                {isEndDateEnabled && (
                    <DateTimePicker
                        control={control}
                        name="endDate"
                        label={t('labels.endDate', 'Ngày kết thúc')}
                        disabled={!isEndDateEnabled}
                        size="medium"
                        includeTime={false}
                        placeholder={t('labels.selectDate', 'Chọn ngày')}
                    />
                )}
            </div>
        </div>
    )
}

export default EffectiveDatesSection
